import { CLASS_NAMES } from '../../utils/constants'
import Empty from './Empty'
import Player from './Player'

export default class Interactive extends Empty {
  constructor(id, level) {
    super(id, level)
    this.ephemeral = true
  }
  overrunBy(el) {
    if (el.isClass(Player)) {
      this.level.onInteractWith(this)
    }
  }
}

Interactive.className = CLASS_NAMES.INTERACTIVE
